export default [
  {
    fieldName: 'FirstName',
    isRequired: true,
    label: 'First name',
    type: 'text',
  },
  {
    fieldName: 'LastName',
    isRequired: true,
    label: 'Last name',
    type: 'text',
  },
  {
    fieldName: 'Email',
    isRequired: true,
    label: 'E-mail',
    type: 'email',
  },
  {
    fieldName: 'Phone',
    isRequired: true,
    label: 'Phone',
    type: 'text',
  },
  {
    fieldName: 'Note',
    isRequired: true,
    label: 'Note',
    type: 'textarea',
  },
];


// WEBPACK FOOTER //
// ./src/formFields/inquiry.tsx